export const ADMIN_DEFAULT_SPACE_LOGO_CONFIG_ANALYTICS_SOURCE = 'adminDefaultSpaceLogoConfig';
export const ALLOWED_LOGO_FILE_EXTENSIONS = ['.gif', '.jpg', '.jpeg', '.png', '.svg', '.webp'];
